import React from "react";

const FormSocials = (props) => {
  const {
    values,
    handleChange,
    handleBlur,
    errors, touched,
    setFieldValue
  } = props;
  return (
    <React.Fragment>
      <div className="add_utf_listing_section margin-top-45">
        <div className="utf_add_listing_part_headline_part">
          <h3>
            <i className="sl sl-icon-notebook"></i> Contacts
          </h3>
        </div>
        <div className="row with-forms">
          <div className="col-md-6">
            <h5>Line</h5>
            <input
              type="text"
              name="ct_line"
              placeholder=""
              value={`${values.ct_line || ''}`}
              onChange={handleChange}
              onBlur={handleBlur}
              className={errors.ct_line && touched.ct_line ? " error" : ""}
            />
          </div>
        
          <div className="col-md-6">
            <h5>Whatsapp</h5>
            <input
              type="text"
              name="ct_whatsapp"
              placeholder=""
              value={`${values.ct_whatsapp || ''}`}
              onChange={handleChange}
              onBlur={handleBlur}
              className={errors.ct_whatsapp && touched.ct_whatsapp ? " error" : ""}
            />
          </div>
          <div className="col-md-6">
            <h5>Wechat</h5>
            <input
              type="text"
              name="ct_wechat"
              placeholder=""
              value={`${values.ct_wechat || ''}`}
              onChange={handleChange}
              onBlur={handleBlur}
              className={errors.ct_wechat && touched.ct_wechat ? " error" : ""}
            />
          </div>
          <div className="col-md-6">
            <h5>Telegram</h5>
            <input
              type="text"
              name="ct_telegram"
              placeholder=""
              value={`${values.ct_telegram || ''}`}
              onChange={handleChange}
              onBlur={handleBlur}
              className={errors.ct_telegram && touched.ct_telegram ? " error" : ""}
            />
          </div>
          
        </div>
      </div>
    </React.Fragment>
  );
};

export default FormSocials;
